import { Box, Link, Typography } from "@mui/material";
import { FC, useEffect, useRef } from "react";
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import Logo from "@/components/Logo";
import { parse, pickQueries } from '@/utils/queryStringWrapper'
import LayoutPlain from "../LayoutPlain";


const PasswordRecoverySent: FC = () => {
  const queries = parse(useLocation().search)
  const pick = pickQueries(queries)
  const email = pick('email')

  const boxRef = useRef<HTMLElement|null>(null)
  useEffect(() => {
    setTimeout(() => boxRef.current?.focus())
  }, [])
  
  return (
    <LayoutPlain>
      <Helmet>
        <title>Password Recovery | OnData</title>
      </Helmet>
      <Box className="sr-only" role="alert" tabIndex={-1} ref={boxRef} aria-describedby="pass-recover-sent-info"></Box>
      <Box role="article" id="pass-recover-sent-info">
        <Typography
          color="textPrimary"
          sx={{ fontWeight: 'fontWeightBold', mt: 5 }}
          variant="h2"
        >
          Password Reset
        </Typography>
        <Typography
          color="textPrimary"
          variant="body1"
          sx={{ py: 3 }}
        >
          An email has been sent to your email address
          {' '}
          <Link
            color="primary"
            underline="hover"
            variant="body2"
          >
            [{email}]
          </Link>.
          {' '}
          Please check your email to reset your password.
        </Typography>
      </Box>
    </LayoutPlain>
  
  )
}

export default PasswordRecoverySent;
